// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1aUt7","title":"ClientInsurance_title__1ghes","itemText":"ClientInsurance_itemText__10oRM"};